import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { SCUIContent } from '../../../atomic/organisms';
import { SCUIBreadCrumb } from '../../../atomic/molecules';
import { useGlobalData } from '../context/GlobalDataContext';
import { LinearProgress } from '@mui/material';
import { SupportedCurrencies } from './SupportedCurrencies';
import { GD } from '../globalData.classes';

interface TabPanelProps {
    children?: React.ReactNode;
    value: number;
    index: number;
    className?: string;
}

const TabPanel = ({ children, value, index, ...other }: TabPanelProps): React.JSX.Element | null => {
    if (value !== index) return null;
    return (
        <Paper
            component="div"
            role="tabpanel"
            id={`global-tabpanel-${index}`}
            aria-labelledby={`global-tab-${index}`}
            sx={{
                p: '24px',
                display: 'flex',
                flex: 1,
                backgroundColor: 'grey.50',
            }}
            {...other}
        >
            {children}
        </Paper>
    );
};

interface TabConfig {
    label: string;
    Component: React.ComponentType;
    tabClassName: string;
    tabPanelClassName: string;
}

export const GlobalDataLayout = (): React.JSX.Element => {
    const [tabValue, setTabValue] = useState<number>(0);

    const { t } = useTranslation();
    const { isLoading } = useGlobalData();

    const handleChange = (_: any, newValue: number): void => {
        setTabValue(newValue);
    };

    const tabsConfig: TabConfig[] = [
        // {
        //     label: t('globalData.supportedCountries'),
        //     Component: SupportedCountries,
        //     tabClassName: GD.tabSupportedCountries,
        //     tabPanelClassName: GD.tabPanelSupportedCountries,
        // },
        // {
        //     label: t('globalData.supportedLanguages'),
        //     Component: SupportedLanguages,
        //     tabClassName: GD.tabSupportedLanguages,
        //     tabPanelClassName: GD.tabPanelSupportedLanguages,
        // },
        {
            label: t('globalData.supportedCurrencies'),
            Component: SupportedCurrencies,
            tabClassName: GD.tabSupportedCurrencies,
            tabPanelClassName: GD.tabPanelSupportedCurrencies,
        },
    ];

    return (
        <SCUIContent>
            <Box className={GD.page}>
            <Paper
                className={GD.shellPaper}
                component="div"
                sx={{
                    p: '24px',
                    paddingTop: '36px',
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                }}
            >
                {isLoading && <LinearProgress className={GD.loadingLinear} />}
                <div className={GD.breadcrumbSection}>
                    <SCUIBreadCrumb title={t('globalData.title')} componentLink={'/global-data'} />
                </div>
                <div className={GD.tabsWrap}>
                    <Tabs
                        className={GD.tabsRoot}
                        sx={{ marginTop: '12px' }}
                        value={tabValue}
                        onChange={handleChange}
                        aria-label="Global Data Tabs"
                    >
                        {tabsConfig.map((tab, index) => (
                            <Tab
                                key={index}
                                className={tab.tabClassName}
                                sx={{ fontSize: '14px' }}
                                label={tab.label}
                                id={`global-tab-${index}`}
                                aria-controls={`global-tabpanel-${index}`}
                            />
                        ))}
                    </Tabs>
                </div>
                {tabsConfig.map((tab, index) => (
                    <TabPanel key={index} value={tabValue} index={index} className={tab.tabPanelClassName}>
                        <tab.Component />
                    </TabPanel>
                ))}
            </Paper>
            </Box>
        </SCUIContent>
    );
};
